import React from 'react';
import { Link } from 'react-router-dom';
import * as MESSAGES from '../Lib/Messages';

export default class ModalComplete extends React.Component {
    constructor(props) {
        super();
        this.state = {
        };
    }

    render() {
        const { onShow, parameter, exportPDF } = this.props;
        if(!onShow)
            return (null);

        return (
            <div className="modal-block modal-header-color modal-block-success">
                <section className="card">
                    <header className="card-header">
                        <h2 className="card-title">Success!</h2>
                    </header>
                    <div className="card-body">
                        <div className="modal-wrapper">
                            <div className="modal-icon">
                                <i className="fas fa-check"></i>
                            </div>
                            <div className="modal-text">
                                <h4>{MESSAGES.SUCCESS_UPDATE_ANALYSIS}</h4>
                                <p>What would you like to do next?</p>
                            </div>
                        </div>
                    </div>
                    <footer className="card-footer">
                        <div className="row">
                                <div className="col-md-12 text-right">
                                <button className="btn btn-success modal-confirm" onClick={() => exportPDF(this)}>Prepare PDF</button>
                                <Link to="/" className="btn btn-success modal-confirm">Dashboard</Link>
                                <button className="btn btn-default modal-dismiss" onClick={this.props.onHide}>Close</button>
                            </div>
                        </div>
                    </footer>
                </section>
            </div>
        )
	}
}
